// Simple, clean SVG line-icons for the 11 diamond shapes Dreamonds offers.
// Rendered as viewBox=0 0 64 64 so callers can size via width/height/className.
const shapes = {
  Round: (
    <>
      <circle cx="32" cy="32" r="20" />
      <polygon points="32,12 44,24 32,32 20,24" />
      <line x1="20" y1="24" x2="44" y2="24" />
      <line x1="32" y1="12" x2="32" y2="32" />
    </>
  ),
  Oval: (
    <>
      <ellipse cx="32" cy="32" rx="14" ry="20" />
      <polygon points="32,12 42,24 32,32 22,24" />
      <line x1="22" y1="24" x2="42" y2="24" />
    </>
  ),
  Pear: (
    <>
      <path d="M32 10 C 48 22 48 42 32 54 C 16 42 16 22 32 10 Z" />
      <line x1="32" y1="10" x2="32" y2="32" />
      <path d="M22 20 L 32 32 L 42 20" />
    </>
  ),
  Emerald: (
    <>
      <polygon points="18,18 46,18 50,22 50,42 46,46 18,46 14,42 14,22" />
      <polygon points="22,22 42,22 46,26 46,38 42,42 22,42 18,38 18,26" />
      <line x1="14" y1="22" x2="22" y2="22" />
      <line x1="50" y1="22" x2="42" y2="22" />
      <line x1="14" y1="42" x2="22" y2="42" />
      <line x1="50" y1="42" x2="42" y2="42" />
    </>
  ),
  Radiant: (
    <>
      <polygon points="20,16 44,16 50,22 50,42 44,48 20,48 14,42 14,22" />
      <polygon points="24,20 40,20 46,26 46,38 40,44 24,44 18,38 18,26" />
    </>
  ),
  Heart: (
    <>
      <path d="M32 52 C 12 38 12 20 22 16 C 28 14 32 20 32 22 C 32 20 36 14 42 16 C 52 20 52 38 32 52 Z" />
      <path d="M22 22 L 32 32 L 42 22" />
      <line x1="32" y1="22" x2="32" y2="32" />
    </>
  ),
  Marquise: (
    <>
      <path d="M32 10 C 46 22 46 42 32 54 C 18 42 18 22 32 10 Z" />
      <line x1="18" y1="32" x2="46" y2="32" />
      <line x1="32" y1="10" x2="32" y2="54" />
    </>
  ),
  Princess: (
    <>
      <rect x="14" y="14" width="36" height="36" />
      <polygon points="14,14 32,32 50,14" />
      <polygon points="14,50 32,32 50,50" />
      <line x1="14" y1="14" x2="50" y2="50" />
      <line x1="50" y1="14" x2="14" y2="50" />
    </>
  ),
  Cushion: (
    <>
      <path d="M20 14 L 44 14 Q 50 14 50 20 L 50 44 Q 50 50 44 50 L 20 50 Q 14 50 14 44 L 14 20 Q 14 14 20 14 Z" />
      <path d="M24 18 L 40 18 Q 46 18 46 24 L 46 40 Q 46 46 40 46 L 24 46 Q 18 46 18 40 L 18 24 Q 18 18 24 18 Z" />
    </>
  ),
  Square: (
    <>
      <rect x="16" y="16" width="32" height="32" />
      <rect x="22" y="22" width="20" height="20" />
      <line x1="16" y1="16" x2="22" y2="22" />
      <line x1="48" y1="16" x2="42" y2="22" />
      <line x1="16" y1="48" x2="22" y2="42" />
      <line x1="48" y1="48" x2="42" y2="42" />
    </>
  ),
  Asscher: (
    <>
      <polygon points="20,14 44,14 50,20 50,44 44,50 20,50 14,44 14,20" />
      <polygon points="26,20 38,20 44,26 44,38 38,44 26,44 20,38 20,26" />
      <line x1="20" y1="14" x2="26" y2="20" />
      <line x1="44" y1="14" x2="38" y2="20" />
      <line x1="20" y1="50" x2="26" y2="44" />
      <line x1="44" y1="50" x2="38" y2="44" />
    </>
  ),
};

export const DIAMOND_SHAPES = Object.keys(shapes);

export function DiamondShapeIcon({ shape, className = "", strokeWidth = 1.4 }) {
  const paths = shapes[shape] || shapes.Round;
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths}
    </svg>
  );
}
